<script>
import SettingsColors from './settings-colors';

export default {
    name: 'settings-utility-colors',
    extends: SettingsColors,

    data() {
        return {
            title: 'Utility Colors',
            colorCategory: 'utility',
        };
    },
};
</script>
